module.exports = require("@swa-ui/core/src/NumberSelectorGroup/NumberSelectorGroup.module.scss");